// Centralized API Service — single source of truth for all form submissions

const LEAD_API_URL = 'https://leadapi.crmbytes.com/api/Lead/AddLead';
const GEO_API_URL = 'https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation';

// ─── Country List (single source) ──────────────────────────────────────────
export const getCountryList = () => [
  { code: 'US', name: 'United States', dialCode: 1, flag: '\u{1F1FA}\u{1F1F8}' },
  { code: 'CA', name: 'Canada', dialCode: 1, flag: '\u{1F1E8}\u{1F1E6}' },
  { code: 'GB', name: 'United Kingdom', dialCode: 44, flag: '\u{1F1EC}\u{1F1E7}' },
  { code: 'AU', name: 'Australia', dialCode: 61, flag: '\u{1F1E6}\u{1F1FA}' },
  { code: 'IN', name: 'India', dialCode: 91, flag: '\u{1F1EE}\u{1F1F3}' },
  { code: 'PK', name: 'Pakistan', dialCode: 92, flag: '\u{1F1F5}\u{1F1F0}' },
  { code: 'DE', name: 'Germany', dialCode: 49, flag: '\u{1F1E9}\u{1F1EA}' },
  { code: 'FR', name: 'France', dialCode: 33, flag: '\u{1F1EB}\u{1F1F7}' },
  { code: 'IT', name: 'Italy', dialCode: 39, flag: '\u{1F1EE}\u{1F1F9}' },
  { code: 'ES', name: 'Spain', dialCode: 34, flag: '\u{1F1EA}\u{1F1F8}' },
  { code: 'NL', name: 'Netherlands', dialCode: 31, flag: '\u{1F1F3}\u{1F1F1}' },
  { code: 'BE', name: 'Belgium', dialCode: 32, flag: '\u{1F1E7}\u{1F1EA}' },
  { code: 'CH', name: 'Switzerland', dialCode: 41, flag: '\u{1F1E8}\u{1F1ED}' },
  { code: 'AT', name: 'Austria', dialCode: 43, flag: '\u{1F1E6}\u{1F1F9}' },
  { code: 'SE', name: 'Sweden', dialCode: 46, flag: '\u{1F1F8}\u{1F1EA}' },
  { code: 'NO', name: 'Norway', dialCode: 47, flag: '\u{1F1F3}\u{1F1F4}' },
  { code: 'DK', name: 'Denmark', dialCode: 45, flag: '\u{1F1E9}\u{1F1F0}' },
  { code: 'FI', name: 'Finland', dialCode: 358, flag: '\u{1F1EB}\u{1F1EE}' },
  { code: 'PL', name: 'Poland', dialCode: 48, flag: '\u{1F1F5}\u{1F1F1}' },
  { code: 'CZ', name: 'Czech Republic', dialCode: 420, flag: '\u{1F1E8}\u{1F1FF}' },
  { code: 'IE', name: 'Ireland', dialCode: 353, flag: '\u{1F1EE}\u{1F1EA}' },
  { code: 'PT', name: 'Portugal', dialCode: 351, flag: '\u{1F1F5}\u{1F1F9}' },
  { code: 'GR', name: 'Greece', dialCode: 30, flag: '\u{1F1EC}\u{1F1F7}' },
  { code: 'NZ', name: 'New Zealand', dialCode: 64, flag: '\u{1F1F3}\u{1F1FF}' },
  { code: 'SG', name: 'Singapore', dialCode: 65, flag: '\u{1F1F8}\u{1F1EC}' },
  { code: 'MY', name: 'Malaysia', dialCode: 60, flag: '\u{1F1F2}\u{1F1FE}' },
  { code: 'TH', name: 'Thailand', dialCode: 66, flag: '\u{1F1F9}\u{1F1ED}' },
  { code: 'PH', name: 'Philippines', dialCode: 63, flag: '\u{1F1F5}\u{1F1ED}' },
  { code: 'ID', name: 'Indonesia', dialCode: 62, flag: '\u{1F1EE}\u{1F1E9}' },
  { code: 'VN', name: 'Vietnam', dialCode: 84, flag: '\u{1F1FB}\u{1F1F3}' },
  { code: 'JP', name: 'Japan', dialCode: 81, flag: '\u{1F1EF}\u{1F1F5}' },
  { code: 'KR', name: 'South Korea', dialCode: 82, flag: '\u{1F1F0}\u{1F1F7}' },
  { code: 'CN', name: 'China', dialCode: 86, flag: '\u{1F1E8}\u{1F1F3}' },
  { code: 'HK', name: 'Hong Kong', dialCode: 852, flag: '\u{1F1ED}\u{1F1F0}' },
  { code: 'TW', name: 'Taiwan', dialCode: 886, flag: '\u{1F1F9}\u{1F1FC}' },
  { code: 'AE', name: 'United Arab Emirates', dialCode: 971, flag: '\u{1F1E6}\u{1F1EA}' },
  { code: 'SA', name: 'Saudi Arabia', dialCode: 966, flag: '\u{1F1F8}\u{1F1E6}' },
  { code: 'ZA', name: 'South Africa', dialCode: 27, flag: '\u{1F1FF}\u{1F1E6}' },
  { code: 'BR', name: 'Brazil', dialCode: 55, flag: '\u{1F1E7}\u{1F1F7}' },
  { code: 'MX', name: 'Mexico', dialCode: 52, flag: '\u{1F1F2}\u{1F1FD}' },
  { code: 'AR', name: 'Argentina', dialCode: 54, flag: '\u{1F1E6}\u{1F1F7}' },
  { code: 'CL', name: 'Chile', dialCode: 56, flag: '\u{1F1E8}\u{1F1F1}' },
  { code: 'CO', name: 'Colombia', dialCode: 57, flag: '\u{1F1E8}\u{1F1F4}' },
  { code: 'PE', name: 'Peru', dialCode: 51, flag: '\u{1F1F5}\u{1F1EA}' },
  { code: 'TR', name: 'Turkey', dialCode: 90, flag: '\u{1F1F9}\u{1F1F7}' },
  { code: 'RU', name: 'Russia', dialCode: 7, flag: '\u{1F1F7}\u{1F1FA}' },
  { code: 'UA', name: 'Ukraine', dialCode: 380, flag: '\u{1F1FA}\u{1F1E6}' },
  { code: 'EG', name: 'Egypt', dialCode: 20, flag: '\u{1F1EA}\u{1F1EC}' },
  { code: 'NG', name: 'Nigeria', dialCode: 234, flag: '\u{1F1F3}\u{1F1EC}' },
  { code: 'KE', name: 'Kenya', dialCode: 254, flag: '\u{1F1F0}\u{1F1EA}' },
  { code: 'BD', name: 'Bangladesh', dialCode: 880, flag: '\u{1F1E7}\u{1F1E9}' },
  { code: 'VE', name: 'Venezuela', dialCode: 58, flag: '\u{1F1FB}\u{1F1EA}' },
  { code: 'IL', name: 'Israel', dialCode: 972, flag: '\u{1F1EE}\u{1F1F1}' },
];

// ─── GeoLocation API ───────────────────────────────────────────────────────
let geoCache = null;

export const getGeoLocation = async () => {
  if (geoCache) return geoCache;

  try {
    const response = await fetch(GEO_API_URL, {
      method: 'GET',
      headers: { 'accept': 'text/plain' }
    });
    const data = await response.json();

    if (data.isSuccess && data.data) {
      geoCache = { success: true, data: data.data, raw: data };
      return geoCache;
    }
    return { success: false, data: null, raw: null };
  } catch (error) {
    console.error('GeoLocation API error:', error);
    return { success: false, data: null, raw: null };
  }
};

// Helper: resolve country from geo data
export const getDetectedCountry = async () => {
  const geo = await getGeoLocation();
  const countries = getCountryList();
  if (geo.success && geo.data) {
    const match = countries.find(c => c.code === geo.data.countryCode);
    return {
      countryCode: geo.data.countryCode,
      countryName: geo.data.countryName,
      dialCode: match ? match.dialCode : 1,
      city: geo.data.cityName || '',
      state: geo.data.regionName || '',
      ipAddress: geo.data.ipAddress || '',
      geoData: geo.data,
      rawGeo: geo.raw,
    };
  }
  return {
    countryCode: 'US',
    countryName: 'United States',
    dialCode: 1,
    city: '',
    state: '',
    ipAddress: '',
    geoData: null,
    rawGeo: null,
  };
};

// ─── Lead Submission API ────────────────────────────────────────────────────
/**
 * Submit a lead to the CRM.
 *
 * @param {Object} params
 * @param {string} params.name
 * @param {string} params.email
 * @param {string} params.phoneNumber     – numeric only, NO dial code prefix
 * @param {number} params.countryDialCode – e.g. 1, 92, 31
 * @param {string} params.country         – ISO code, e.g. "US", "PK"
 * @param {string} [params.description]
 * @param {string} [params.packageTitle]
 * @param {number} [params.packageAmount]
 * @param {Object} [params.geoData]       – raw geo.data from getGeoLocation
 * @param {Object} [params.rawGeo]        – full geo response for geoLocation field
 */
export const submitLead = async (params) => {
  const {
    name,
    email,
    phoneNumber,
    countryDialCode,
    country,
    description = '',
    packageTitle = '',
    packageAmount = 0,
    geoData = null,
    rawGeo = null,
  } = params;

  const payload = {
    name,
    email,
    countryDialCode: Number(countryDialCode),
    country,
    phoneNumber: phoneNumber.replace(/\D/g, ''),   // numeric only
    ipAddress: geoData?.ipAddress || '',
    description: description || 'Trademark registration service needed',
    pageUrl: window.location.href,
    city: geoData?.cityName || '',
    state: geoData?.regionName || '',
    geoLocation: rawGeo ? JSON.stringify(rawGeo) : '',
    packageTitle: packageTitle || '',
    packageAmount: packageAmount || 0,
  };

  try {
    const response = await fetch(LEAD_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'accept': 'text/plain' },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    // 200 — success
    if (response.status === 200 && data.isSuccess && data.data?.customerId) {
      return {
        success: true,
        customerId: data.data.customerId,
        redirectUrl: `/application/main?customerid=${data.data.customerId}`,
      };
    }

    // 401 — unauthorized (domain not configured, etc.)
    if (response.status === 401) {
      return {
        success: false,
        error: data.message || 'Unauthorized access',
      };
    }

    // 400 — validation error from CRM
    if (response.status === 400) {
      return {
        success: false,
        error: data.errorMessage || data.data?.message || 'Invalid form data',
      };
    }

    // Other errors
    return {
      success: false,
      error: data.errorMessage || data.message || 'An error occurred. Please try again.',
    };
  } catch (error) {
    console.error('Lead submission error:', error);
    return {
      success: false,
      error: 'Unable to submit form. Please check your connection and try again.',
    };
  }
};

export default { getGeoLocation, getDetectedCountry, submitLead, getCountryList };
